export function convertMStoKmH(value: number) {
    return ((value * 60 * 60) / (1000)).toFixed(0)
}